<script>
import ProfileNewPastAttention from "@/components/student-profile/components/new_attention/ProfileNewAttention.vue"

export default {
  name: "ProfileNewPastAttention",
  extends: ProfileNewPastAttention,
  props: {
    past: {
      type: Boolean,
      default() {
        return true
      }
    }
  }
}
</script>
